import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      // component: () => import('@/views/home/index'),
      redirect: '/author'
    },
    {
      path: '/home',
      name: 'homeIndex',
      component: () => import('@/views/home/index'),
      meta: {
        title: 'HECATE官方商城'
      }
    },
    {
      path: '/classify',
      name: 'classifyIndex',
      component: () => import('@/views/classify/index'),
      meta: {
        title: '商品分类'
      }
    },
    {
      path: '/classifyticket',
      name: 'classifyticket',
      component: () => import('@/views/classify/classifyticket'),
      meta: {
        title: '优惠商品'
      }
    },
    {
      path: '/login',
      component: () => import('@/views/login/index'),
      name: 'login',
      meta: {
        title: '登录'
      }
    },
    {
      path: '/search',
      component: () => import('@/views/search/index'),
      name: 'search',
      meta: {
        title: '搜索'
      }
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('@/views/register/index'),
      meta: {
        title: '绑定手机'
      }
    },
    {
      path: '/backPassword',
      name: 'backPassword',
      component: () => import('@/views/backPassword/index'),
      meta: {
        title: '找回密码'
      }
    },
    {
      path: '/editPassword',
      name: 'editPassword',
      component: () => import('@/views/newPassword/editPassword'),
      meta: {
        title: '修改密码'
      }
    },
    {
      path: '/newProduct',
      name: 'newProduct',
      component: () => import('@/views/newProduct/index'),
      meta: {
        title: '新品预售'
      }
    },
    {
      path: '/collage',
      name: 'collage',
      component: () => import('@/views/collage/index'),
      meta: {
        title: '今日拼团'
      }
    },
    {
      path: '/secKill',
      name: 'secKill',
      component: () => import('@/views/secKill/index'),
      meta: {
        title: '秒杀活动'
      }
    },
    {
      path: '/disCut',
      name: 'disCut',
      component: () => import('@/views/disCut/index'),
      meta: {
        title: '折扣活动'
      }
    },
    {
      path: '/act/guaranteedact',
      name: 'guaranteedAct',
      component: () => import('@/views/act/guaranteedact'),
      meta: {
        title: '延保服务活动'
      }
    },
    {
      path: '/newPassword',
      name: 'newPassword',
      component: () => import('@/views/newPassword/index'),
      meta: {
        title: '设置新密码'
      }
    },
    {
      path: '/orderDetail',
      name: 'orderDetail',
      component: () => import('@/views/orderDetail/index'),
      meta: {
        title: '商品详情'
      }
    },
    {
      path: '/orderDetail/questions',
      name: 'questions',
      component: () => import('@/views/orderDetail/questions'),
      meta: {
        title: 'EDIFIER问答'
      }
    },
    {
      path: '/orderDetail/questionsdetail',
      name: 'questionsdetail',
      component: () => import('@/views/orderDetail/questionsdetail'),
      meta: {
        title: 'EDIFIER问答'
      }
    },
    {
      path: '/orderDetail/answer',
      name: 'answer',
      component: () => import('@/views/orderDetail/answer'),
      meta: {
        title: '我来回答',
        requireLogin: true
      }
    },
    {
      path: '/orderDetail/issue',
      name: 'issue',
      component: () => import('@/views/orderDetail/issue'),
      meta: {
        title: '发布问题',
        requireLogin: true
      }
    },
    {
      path: '/showphoto',
      name: 'showphoto',
      component: () => import('@/views/showphoto/index'),
      meta: {
        title: '晒图征集活动'
      }
    },
    {
      path: '/showphoto/actdetail',
      name: 'showphoto',
      component: () => import('@/views/showphoto/actdetail'),
      meta: {
        title: '晒图征集活动'
      }
    },
    {
      path: '/showphoto/workdetail',
      name: 'workdetail',
      component: () => import('@/views/showphoto/workdetail'),
      meta: {
        title: '照片详情'
      }
    },
    {
      path: '/showphoto/allworks',
      name: 'allworks',
      component: () => import('@/views/showphoto/allworks'),
      meta: {
        title: '晒图征集活动'
      }
    },
    {
      path: '/showphoto/upload',
      name: 'upload',
      component: () => import('@/views/showphoto/upload'),
      meta: {
        title: '晒图征集活动',
        requireLogin: true
      }
    },
    {
      path: '/showphoto/prize',
      name: 'prize',
      component: () => import('@/views/showphoto/prize'),
      meta: {
        title: '获奖名单'
      }
    },
    {
      path: '/page',
      name: 'page',
      component: () => import('@/views/act/cuspage'),
      meta: {
        title: ''
      }
    },
    {
      path: '/receive',
      name: 'receive',
      component: () => import('@/views/coupon/receive'),
      meta: {
        title: '优惠券',
        requireLogin: false // 是否需要登录才可使用该功能
      }
    },
    {
      path: '/receiveCoupon',
      name: 'receiveCoupon',
      component: () => import('@/views/receiveCoupon/index'),
      meta: {
        title: '领取优惠券',
        requireLogin: true // 是否需要登录才可使用该功能
      }
    },
    {
      path: '/trialOrder',
      name: 'trialOrder',
      component: () => import('@/views/trialOrder/index'),
      meta: {
        title: '产品试用'
      }
    },
    // {
    //   path: '/gitshoppingCard',
    //   name: 'shoppingCard',
    //   component: () => import('@/views/shoppingCard/index'),
    //   meta: {
    //     title: '购物车'
    //   }
    // },
    {
      path: '/nowPay',
      name: 'nowPay',
      component: () => import('@/views/nowPay/index'),
      meta: {
        title: '选择支付方式',
        requireLogin: true // 是否需要登录才可使用该功能
      }
    },
    {
      path: '/confirmOrder',
      name: 'confirmOrder',
      component: () => import('@/views/confirmOrder/index'),
      meta: {
        title: '确认订单',
        requireLogin: true // 是否需要登录才可使用该功能
      }
    },
    {
      path: '/invoice',
      name: 'invoice',
      component: () => import('@/views/invoice/index'),
      meta: {
        title: '发票信息',
        requireLogin: true // 是否需要登录才可使用该功能
      }
    },
    {
      path: '/coupon',
      name: 'coupon',
      component: () => import('@/views/coupon/index'),
      meta: {
        title: '优惠券',
        requireLogin: true // 是否需要登录才可使用该功能
      }
    },
    {
      path: '/user/coupon',
      name: 'mycoupon',
      component: () => import('@/views/user/coupon'),
      meta: {
        title: '我的优惠券'
      }
    },
    {
      path: '/myIntegral',
      name: 'myIntegral',
      component: () => import('@/views/myIntegral/index'),
      meta: {
        title: '我的积分'
      }
    },
    {
      path: '/integralGet',
      name: 'integralGet',
      component: () => import('@/views/integralGet/index'),
      meta: {
        title: '积分提现',
        requireLogin: true // 是否需要登录才可使用该功能
      }
    },
    {
      path: '/userInfo',
      name: 'userInfo',
      component: () => import('@/views/userInfo/index'),
      meta: {
        title: '会员资料'
      }
    },
    {
      path: '/address',
      name: 'address',
      component: () => import('@/views/address/index'),
      meta: {
        title: '地址管理',
        requireLogin: true // 是否需要登录才可使用该功能
      }
    },
    {
      path: '/addressNew',
      name: 'addressNew',
      component: () => import('@/views/address/addressNew'),
      meta: {
        title: '新增地址',
        requireLogin: true // 是否需要登录才可使用该功能
      }
    },
    {
      path: '/usercenter',
      name: 'userCenter',
      component: () => import('@/views/user/index.vue'),
      meta: {
        title: '会员中心',
        requireLogin: true // 是否需要登录才可使用该功能
      }
    },
    {
      path: '/userservice',
      name: 'userService',
      component: () => import('@/views/user/service.vue'),
      meta: {
        title: '客服中心',
        requireLogin: true // 是否需要登录才可使用该功能
      }
    },
    {
      path: '/usercenter/myorder',
      name: 'myOrder',
      component: () => import('@/views/user/myOrder.vue'),
      meta: {
        title: '我的订单',
        requireLogin: true // 是否需要登录才可使用该功能
      }
    },
    {
      path: '/usercenter/orderdetail',
      name: 'uc-orderDetail',
      component: () => import('@/views/user/orderDetail.vue'),
      meta: {
        title: '订单详情',
        requireLogin: true // 是否需要登录才可使用该功能
      }
    },
    {
      path: '/usercenter/orderlogistics',
      name: 'uc-orderLogistics',
      component: () => import('@/views/user/orderLogistics.vue'),
      meta: {
        title: '订单跟踪'
      }
    },
    {
      path: '/usercenter/refunds',
      name: 'uc-refunds',
      component: () => import('@/views/user/refunds.vue'),
      meta: {
        title: '申请退换货'
      }
    },
    {
      path: '/usercenter/submitrefunds',
      name: 'uc-submitRefunds',
      component: () => import('@/views/user/submitRefunds.vue'),
      meta: {
        title: '退货退款'
      }
    },
    {
      path: '/usercenter/refunddetail',
      name: 'uc-refundDetail',
      component: () => import('@/views/user/refundDetail.vue'),
      meta: {
        title: '退款详情'
      }
    },
    {
      path: '/usercenter/replace',
      name: 'uc-replace',
      component: () => import('@/views/user/replace.vue'),
      meta: {
        title: '换货'
      }
    },
    {
      path: '/usercenter/comments',
      name: 'uc-comments',
      component: () => import('@/views/user/comments.vue'),
      meta: {
        title: '我的评价'
      }
    },
    {
      path: '/usercenter/membership',
      name: 'membership ',
      component: () => import('@/views/user/membership .vue'),
      meta: {
        title: '会员权益'
      }
    },
    {
      path: '/usercenter/commentsDetail',
      name: 'uc-commentsDetail',
      component: () => import('@/views/user/commentsDetail.vue'),
      meta: {
        title: '用户评价'
      }
    },
    {
      path: '/usercenter/submitcomments',
      name: 'uc-submitcomments',
      component: () => import('@/views/user/submitComments.vue'),
      meta: {
        title: '商品评价'
      }
    },
    {
      path: '/usercenter/NewPassword',
      name: 'ucNewPassword',
      component: () => import('@/views/backPassword/index'),
      meta: {
        title: '修改密码'
      }
    },
    {
      path: '/cooperation',
      name: 'cooperation',
      component: () => import('@/views/cooperation/index'),
      meta: {
        title: '积分提现申请提交'
      }
    },
    {
      path: '/guarantee',
      name: 'guarantee',
      component: () => import('@/views/guarantee/index'),
      meta: {
        title: '延保服务活动'
      }
    },
    {
      path: '/usercenter/guaranteed',
      name: 'ucGuaranteed',
      component: () => import('@/views/user/guaranteed'),
      meta: {
        title: '延保凭证'
      }
    },
    {
      path: '/partner/index',
      name: 'partnerIndex',
      component: () => import('@/views/partner/index'),
      meta: {
        title: '品牌大使'
      }
    },
    {
      path: '/partner/apply',
      name: 'partnerApply',
      component: () => import('@/views/partner/apply'),
      meta: {
        title: '申请合作商户'
      }
    },
    {
      path: '/shoppingtrolley',
      name: 'shoppingtrolley',
      component: () => import('@/views/shoppingtrolley/index.vue'),
      meta: {
        title: '购物车',
        requireLogin: true
      }
    },
    {
      path: '/author',
      name: 'author',
      component: () => import('@/views/auth/index.vue'),
      meta: {
        title: '首页'
      }
    },
    {
      path: '/agree',
      name: 'agree',
      component: () => import('@/views/agree/agree.vue'),
      meta: {
        title: '隐私协议'
      }
    },
    {
      path: '/demo',
      name: 'demo',
      component: () => import('@/views/demo/index.vue'),
      meta: {
        title: '自定义组件展示'
      }
    },
    {
      path: '*',
      name: '404',
      component: () => import('@/components/404.vue'),
      meta: {
        title: 'Not Found'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js